"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var types_1 = require("../types");
var core_1 = require("@veeam/core");
var CommandMenu_1 = require("../../CommandMenu");
var Icon_1 = require("../../Icon");
var helpers_1 = require("../../helpers");
var UISplitButtonBase = helpers_1.createUIElement('SplitButton', function (_a, ref) {
    var className = _a.className, items = _a.items, iconSrc = _a.iconSrc, text = _a.text, disabled = _a.disabled, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "items", "iconSrc", "text", "disabled", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var canAction = core_1.useGuard().canAction;
    var parseItems = items
        .filter(function (_a) {
        var hasGuard = _a.hasGuard, guardAction = _a.guardAction, resourceName = _a.resourceName;
        return hasGuard ? canAction(guardAction !== null && guardAction !== void 0 ? guardAction : core_1.ACTIONS.Write, resourceName) : true;
    })
        .map(function (_a) {
        var text = _a.text, onClick = _a.onClick, iconSrc = _a.iconSrc, hasGuard = _a.hasGuard, guardAction = _a.guardAction, resourceName = _a.resourceName, restItemProps = __rest(_a, ["text", "onClick", "iconSrc", "hasGuard", "guardAction", "resourceName"]);
        return __assign(__assign({}, restItemProps), { text: text,
            onClick: onClick, icon: iconSrc, hasGuard: hasGuard,
            guardAction: guardAction,
            resourceName: resourceName });
    });
    return (react_1.default.createElement(CommandMenu_1.CommandMenu, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'toolbar-splitbutton', className: "vm-SplitButton " + className, items: parseItems, controlIcon: iconSrc && react_1.default.createElement(Icon_1.Icon, { src: iconSrc, disabled: disabled }), controlText: text, disabled: disabled, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
exports.SplitButton = Object.assign({}, UISplitButtonBase, {
    groupType: types_1.TOOLBAR_GROUP_TYPE.splitButton
});
//# sourceMappingURL=SplitButton.js.map